<template>
  <div id="my-account-users">
    <div class="alert -danger" v-if="errors.cantFetchTokensList">
      <p>Ocorreu um erro desconhecido ao tentar obter os tokens de sua conta, por favor tente novamente.</p>
    </div>

    <table class="list">
      <thead>
      <tr>
        <th>Nome</th>
        <th>E-mail</th>
        <th>Permissão</th>
        <th>Ativo?</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="user in users" class="row">
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td>{{ roleLabel(user.role) }}</td>
        <td><div class="badge" :class="[user.enable ? '-success' : '-danger']">{{ user.enable ? 'Sim' : 'Não' }}</div></td>
        <td class="cell -expanseaction">
          <button class="btn -sm btn-primary" @click="editUser(user)">
            <ion-icon name="pencil" role="img" class="xs hydrated md"></ion-icon>
          </button>
          <button class="btn -sm" :class="[user.enable ? 'btn-danger' : 'btn-success']" @click="toggleUser(user.id, user.enable)">{{ user.enable ? 'Desativar' : 'Ativar' }}</button>
        </td>
      </tr>
      </tbody>
    </table>


    <h2 class="other-title">Convites aguardando serem aceitos</h2>

    <table class="list">
      <thead>
      <tr>
        <th>Nome</th>
        <th>E-mail</th>
        <th>Permissão</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="invite in invites" class="row">
        <td>{{ invite.name }}</td>
        <td>{{ invite.email }}</td>
        <td>{{ roleLabel(invite.role) }}</td>
        <td class="cell -expanseaction">
          <button class="btn -sm btn-danger" @click="deleteInvite(invite.id)">Deletar</button>
        </td>
      </tr>
      </tbody>
    </table>

    <loader v-if="loading"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/support/components/Loader.vue';

export default {
  name: 'UsersList',

  data() {
    return {
      loading: false,
      errors: {
        cantFetchTokensList: false,
      },
    };
  },

  methods: {
    /**
     * Fetch the tokens list.
     *
     * @returns {Promise<void>}
     */
    async fetchTokensList() {
      try {
        this.loading = true;
        this.resetErrors();

        await Promise.all([
          this.$store.dispatch('auth/fetchUsersList'),
          this.$store.dispatch('auth/fetchInvitesList'),
        ]);
      } catch {
        this.errors.cantFetchTokensList = true;
      } finally {
        this.loading = false;
      }
    },

    async deleteInvite(id) {
      try {
        this.loading = true;

        await this.$store.dispatch('auth/deleteInvite', id);
        await this.$store.dispatch('auth/fetchInvitesList');
        this.$notify({
          group: 'app',
          type: 'success',
          title: 'Sucesso!',
          text: 'Convite deletado com sucesso.',
        });
      } catch {
        this.errors.cantFetchTokensList = true;
      } finally {
        this.loading = false;
      }
    },

    async toggleUser(id, enable) {
      try {
        this.loading = true;

        await this.$store.dispatch('auth/toggleUser', id);
        await this.$store.dispatch('auth/fetchUsersList');

        this.$notify({
          group: 'app',
          type: 'success',
          title: 'Sucesso!',
          text: `Usuário ${enable ? 'desativado' : 'ativado'} com sucesso.`,
        });
      } catch {
        this.errors.cantFetchTokensList = true;
      } finally {
        this.loading = false;
      }
    },

    async editUser(user) {
      await this.$router.push({
        name: 'Auth-My-Account-User-Edit',
        params: { user },
      });
    },

    /**
     * Reset the errors from page.
     */
    resetErrors() {
      this.errors.cantFetchTokensList = false;
    },

    roleLabel(role) {
      return {
        1: 'Master',
        2: 'Operador',
      }[role];
    },
  },

  computed: {
    ...mapState('auth', {
      users: 'users',
      invites: 'invites',
    }),
  },

  mounted() {
    this.fetchTokensList();
  },

  directives: {
  },

  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>
#my-account-users {
  .other-title {
    --text-opacity: 1;
    color: #2E386B;
    color: rgba(46, 56, 107, var(--text-opacity));
    text-transform: uppercase;
    font-size: 0.875rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    margin-bottom: 15px;
    margin-top: 45px;
  }
  > table.list {
    > thead,
    > tbody {
      > tr {
        > td {
          &.-expanseaction {
            @apply text-center;
            @apply w-full;
            display: flex;
            justify-content: flex-end;
            gap: 8px;

            .btn {
              > ion-icon {
                left: 0;
              }
            }
          }
        }
      }
    }
  }
}
</style>
